import { createContext, ReactNode } from "react"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

export interface OrganizationSettingsContextType {
  organization: Omit<OrganizationsResponses.Organization, "users">
  displaySettingsId: string | null
  displaySettings: OrganizationsResponses.Organization["settings"]["displaySettings"]
}

export const OrganizationSettingsContext = createContext<
  OrganizationSettingsContextType | undefined
>(undefined)

interface OrganizationSettingsProviderProps {
  children: ReactNode
  organization: Omit<OrganizationsResponses.Organization, "users">
}

export const OrganizationSettingsProvider = ({
  children,
  organization,
}: OrganizationSettingsProviderProps) => {
  const displaySettingsId =
    organization.settings.displaySettings.length > 0
      ? organization.settings.displaySettings[0].id
      : null

  // TODO: these values are all useful in the new interface ?
  const value = {
    organization,
    displaySettingsId,
    displaySettings: organization.settings.displaySettings,
  }

  return (
    <OrganizationSettingsContext.Provider value={value}>
      {children}
    </OrganizationSettingsContext.Provider>
  )
}
